import PropTypes from "prop-types";
import React, { useContext, useRef, useState } from "react";

import styled from "styled-components/macro";

import { useSaveDefaultFilters } from "Boards/APIReactQuery/queries";
import { BoardContext } from "Boards/BoardContext";

import { HoverChild, HoverParent } from "UI/HoverChildren";

import SaveDefaultPopover from "./SaveDefaultPopover";

SaveDefaultFilter.propTypes = {
  currentlyFiltering: PropTypes.bool,
};

/**
 * Saves the current filters as the default filter for the current board
 * On a report, it essentially overrides the current report filters
 */
export default function SaveDefaultFilter({ currentlyFiltering }) {
  const buttonRef = useRef();
  const [{ savedBoardFilter, boardID, groupID }] = useContext(BoardContext);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showPopover, setShowPopover] = useState(false);

  const { mutate, reset, isSuccess, isError } = useSaveDefaultFilters({
    boardID,
    onSuccess: () => {
      setTimeout(() => {
        reset();
      }, 2000);
    },
  });

  const handleClick = () => {
    // Immediately save the current filters if there is no saved filter
    if (!savedBoardFilter) {
      let filters =
        window.fnReactBus.filtersPanel.filterBuilder.buildRequest(false);

      mutate({ boardID, groupID, filters });
      return;
    }

    // Verify if the user wants to override the current saved filter
    if (!showPopover) {
      setShowTooltip(false);
      setShowPopover(true);
    } else {
      setShowPopover(false);
    }
  };

  const getActiveElement = () => {
    if (showTooltip && !showPopover) return "tooltip";
    if (showPopover) return "popover";
    return null;
  };
  const activeElement = getActiveElement();

  return (
    <>
      <HoverParent
        hoverStyle={{
          background: "hsl(0 0% 0% / .2)",
          borderRadius: 4,
        }}
        style={{
          borderRadius: "3px",
          border: "none",
        }}
      >
        <HoverChild>
          <IconButton
            ref={buttonRef}
            data-cy="saveDefaultFilter"
            $currentlyFiltering={currentlyFiltering}
            onClick={handleClick}
            className={`fad ${isSuccess ? "fa-check-circle" : "fa-save"}`}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          />
        </HoverChild>
      </HoverParent>

      <SaveDefaultPopover
        showPopover={showPopover}
        setShowPopover={setShowPopover}
        setShowTooltip={setShowTooltip}
        buttonRef={buttonRef}
        activeElement={activeElement}
      />
    </>
  );
}

const IconButton = styled.button`
  cursor: pointer;
  display: block;
  font-size: 16px;
  width: 26px;
  height: 25px;
  line-height: 22px;
  text-align: center;
  color: ${(p) => (p.$currentlyFiltering ? "#fff" : "#15436a")};
  border: none;
  background: transparent;
  transition: 0.2s;
  z-index: 1;

  &:hover {
    transform: scale(1.2);
  }
  &:active {
    transform: scale(1);
  }
  &.focused {
    /* background: #13426b; */
  }
`;

export const MUTATION_TYPE = {
  SAVE: "save",
  CLEAR: "clear",
};
